import { useWatch } from 'react-hook-form/dist/index.ie11';
import { CorpSubscriptionFundingType } from 'src/types/Corp';
import { GhPlusSubscriptionFundingFormField } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';

type UseMembershipPayerOptionsControlReturn = {
  isCorpFundingDisabled: boolean;
  isEmployeeFundingDisabled: boolean;
};

type fundingWatchType = {
  [key: string]: GhPlusSubscriptionFundingFormField;
};

export function useMembershipPayerOptionsControl(
  name: string,
  disabled: boolean,
  disabledCorpFunding: boolean
): UseMembershipPayerOptionsControlReturn {
  const { [name]: payerOption } = useWatch({
    name: [name],
  }) as fundingWatchType;

  const getCorpFundingDisabledState = (): boolean => {
    if (disabledCorpFunding) {
      return true;
    }

    // funding/payer field is of type CORP when Client is selected in the UI
    if (disabled && payerOption !== CorpSubscriptionFundingType.CORP) {
      return true;
    }

    return false;
  };

  const isEmployeeFundingDisabled =
    disabled && payerOption !== CorpSubscriptionFundingType.EMPLOYEE;

  return {
    isCorpFundingDisabled: getCorpFundingDisabledState(),
    isEmployeeFundingDisabled,
  };
}
